.root {
  --input-wrapper--border-radius: var(--theme--tokens--input--radius, 0px);
  --input-wrapper--font-size: var(--theme--tokens--input--font-size,
      var(--theme--typo--paragraph--size));
  --input-wrapper--line-height: var(--theme--typo--paragraph--line-height);
  --input-wrapper--background: var(--theme--tokens--input--background);
  --input-wrapper--border-width: var(--theme--tokens--input--border-width, 1px);
  --input-wrapper--border-color: var(--theme--tokens--input--border-color, #ced4da);
  --input-wrapper--border-color-focused: var(--theme--tokens--input--focused-border-color);
  --input-wrapper--placeholder-color: var(--theme--tokens--input--placeholder-color,
      var(--theme--color--grey--dark));
  --input-wrapper--left-padding: var(--theme--tokens--input--left-padding);
  --input-wrapper--right-padding: var(--theme--tokens--input--right-padding);
  --input-wrapper--y-padding: var(--theme--tokens--input--y-padding);

  &.hasPrefix {
    .inputWrapper {
      padding-left: calc(var(--input-wrapper--prefix-width) + var(--input-wrapper--left-padding));
    }
  }

  &.hasSuffix {
    .clear {
      right: 38px;
    }

    .inputContent {
      margin-right: var(--input-wrapper--suffix-width);
    }
  }

  &.disabled {
    --input-wrapper--border-color: var(--theme--color--grey--main);

    .inputWrapper {
      pointer-events: none;
      color: var(--theme--color--grey--dark);
      background: var(--theme--color--grey--light);
    }

    .input {
      color: var(--theme--color--grey--dark);
    }
  }

  &.adornmentCell {
    &.hasPrefix {
      .inputWrapper {
        padding-left: calc(var(--input-wrapper--prefix-width) + var(--input-wrapper--left-padding) + var(--theme--sizing--1x));
      }
    }

    &.hasSuffix {
      .input {
        padding-right: calc(var(--input-wrapper--suffix-width) + var(--input-wrapper--right-padding) / 2);
      }
    }

    .prefix {
      height: 100%;
      border-right: solid var(--input-wrapper--border-width) var(--input-wrapper--border-color);
    }

    .suffix {
      height: 100%;
      border-left: solid var(--input-wrapper--border-width) var(--input-wrapper--border-color);
    }
  }

  &.hasError.hasError {
    .inputWrapper {
      --input-wrapper--border-color: var(--theme--color--signal--danger--main);
      --input-wrapper--border-color-focused: var(--theme--color--signal--danger--main);
    }

    .helper,
    .suffix,
    .prefix {
      color: var(--theme--color--signal--danger--main);
    }

    .prefix,
    .suffix {
      border-color: var(--theme--color--signal--danger--main);
    }
  }

  &.type_color {
    .input {
      height: 40px;
      position: relative;

      &::-webkit-color-swatch {
        position: absolute;
        top: 0;
        left: 0;
        height: 40px;
        width: 100%;
        box-sizing: border-box;
        border: none;
        z-index: 1;
      }
    }
  }

  &.type_number {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: textfield;

    .input {

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }
  }

  & {
    width: 100%;

    &:focus-within {

      .inputWrapper,
      .prefix,
      .suffix {
        border-color: var(--input-wrapper--border-color-focused);
      }
    }
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    gap: var(--theme--sizing--05x);
  }

  .prefix,
  .suffix {
    z-index: 1;
    position: absolute;
    overflow: hidden;
    top: 50%;
    transform: translateY(-50%);
    color: var(--input-wrapper--placeholder-color);
    display: flex;
    flex-direction: row;
    justify-items: center;
    align-items: center;
    transition: border-color var(--theme--transition--default);
    padding: 1px var(--input-wrapper--left-padding);
    pointer-events: bounding-box;

    &:empty {
      display: none;
    }
  }

  .prefix {
    left: 0
  }

  .suffix,
  .clear {
    right: 0;
  }

  .inputWrapper {
    position: relative;
    flex: 1;
    box-sizing: border-box;
    //overflow: hidden;
    display: flex;
    border: solid var(--input-wrapper--border-width) var(--input-wrapper--border-color);
    border-radius: var(--input-wrapper--border-radius);
    padding: calc(var(--input-wrapper--y-padding) - var(--input-wrapper--border-width)) calc(var(--input-wrapper--right-padding) - var(--input-wrapper--border-width)) calc(var(--input-wrapper--y-padding) - var(--input-wrapper--border-width)) calc(var(--input-wrapper--left-padding) - var(--input-wrapper--border-width));
    background-color: var(--input-wrapper--background);

    &:focus-within {
      outline: 4px solid var(--theme--color--primary--ultra-light);
    }
  }

  .input {
    width: 100%;
    box-sizing: border-box;
    appearance: none;
    border: none;
    background: transparent;
    outline: none;
    transition: border-color var(--theme--transition--default);
    color: var(--theme--tokens--default-color);
    border-radius: var(--input-wrapper--border-radius);

    &::placeholder {
      color: var(--input-wrapper--placeholder-color);
    }

    &,
    &::placeholder {
      font-family: var(--theme--font--family);
      line-height: var(--input-wrapper--line-height);
      font-size: var(--input-wrapper--font-size);
      font-weight: var(--theme--font--weight-regular);
    }
  }

  .label {
    cursor: pointer;
    width: fit-content;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--theme--sizing--05x)
  }

  .helper {
    font-size: 13px;
    font-weight: var(--theme--font--weight-regular);
    margin-left: 12px;
  }

  .inputContent {
    flex: 1;
    overflow: hidden;
    min-height: 16px;
  }

  .description {
    color: var(--theme--color--grey--ultra-dark);
  }

  .hint {
    display: inline-flex;
    color: var(--theme--color--grey--ultra-dark);
  }
}